import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'almacenesOrden',
})
export class AlmacenesOrdenPipe implements PipeTransform {

  transform(items: any[], filter: string): any {

    if(items){

      return items.sort((a, b) => a[filter] - b[filter]);

    }else {

      return items;

    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/almacenes-orden/almacenes-orden.ts